module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_pawcom.51f4176ab756f11e4222cade0067ffc6.png";